theme.initExperts = function () {
  var modals = {};
  var cur_hash = window.location.hash.replace("#", "");
  var cur_hash_link = document.querySelector(
    `.js-modal-open-expert-modal-${cur_hash}`
  );
  var btnMoreExperts = document.getElementById("ShowMoreExperts");
  var btnLessExperts = document.getElementById("ShowLessExperts");

  initExpertsModals();
  initShowButtons();
  initClearHash();

  if (cur_hash_link != undefined && cur_hash_link != null && cur_hash.length) {
    cur_hash_link.click();
  }

  function initShowButtons() {
    if (btnMoreExperts) {
      btnMoreExperts.addEventListener("click", showMoreExperts);
    }
    if (btnLessExperts) {
      btnLessExperts.addEventListener("click", showLessExperts);
    }
  }

  function initExpertsModals() {
    var buttons = document.querySelectorAll(".experts__link");

    buttons.forEach(function (button) {
      var id = button.dataset.id;
      var modalId = "ExpertModal-" + id;
      var name = "expert-modal-" + id;

      var modal = new theme.Modals(modalId, name, {
        solid: true,
      });
      modals[id] = modal;
      addHash(button, id);
    });
  }

  function showMoreExperts(e) {
    e.preventDefault();
    var hiddenItems = document.querySelectorAll(".experts__hide-item");

    hiddenItems.forEach(function (item) {
      item.classList.remove("experts__hide-item");
      item.classList.add("experts__show-item");
    });

    e.target.style.display = "none";
    btnLessExperts.style.display = "inline-block";
  }

  function showLessExperts(e) {
    e.preventDefault();
    var itemsToHide = document.querySelectorAll(".experts__show-item");

    itemsToHide.forEach(function (item) {
      item.classList.remove("experts__show-item");
      item.classList.add("experts__hide-item");
    });

    e.target.style.display = "none";
    btnMoreExperts.style.display = "inline-block";

    document
      .querySelector("#shopify-section-page-experts-list")
      .scrollIntoView({
        behavior: "smooth",
      });
  }

  function initClearHash() {
    var closeBtns = document.querySelectorAll(".js-experts-close");

    closeBtns.forEach(function (button) {
      button.addEventListener("click", function () {
        clearHash();
      });
    });
  }

  function clearHash() {
    history.pushState(
      "",
      document.title,
      window.location.pathname + window.location.search
    );
  }

  function addHash(btn, id) {
    btn.addEventListener("click", function () {
      window.location.hash = `#${id}`;
    });
  }
};

theme.initExperts();
